import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',//  解决方法： 在配置路由的函数里，把mode: 'history' 改为 mode: 'hash'
    base: '/www/',  //路由加上前辍  -- 如果项目根目录不为域名，则添加该行
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            path: '/',
            // component: resolve => require(['@/components/common/main.vue'], resolve),
             component: resolve => require(['@/components/page/tmp/main.vue'], resolve),
            meta: { title: '自述文件' },
            children: [
                {
                    path: '/index',
                    // name: 'dashboard',
                    component: resolve => require(['@/components/page/index/index.vue'], resolve),
                    meta: {
                        title: '首页',id:1000,
                                content:{
                                  keywords:"关键词",
                                  description:"xxxxxxxxxx描述",
                                },
                        },
                },

// sb_feedback

                {
                    path: '/feedback',
                  //   name: 'conf',
                    component: resolve => require(['@/components/page/feedback/feedback.vue'], resolve),
                    meta: { title: '意见反馈'}
                },

                // ---------------------------   global


              // {
              //       path: '/rediscache', //系统缓存状态
              //      // name: 'business',
              //       component: resolve => require(['@/components/page/rediscache/Index.vue'], resolve),
              //       meta: { title: '系统缓存状态' }
              //   },



                {
                    path: '/article_category',
                  //   name: 'info',
                    component: resolve => require(['@/components/page/article/article_category.vue'], resolve),
                    meta: { title: '文章列表' }
                },
                {
                    path: '/article',
                  //   name: 'info',
                    component: resolve => require(['@/components/page/article/details.vue'], resolve),
                    meta: { title: '文章管理' }
                },

//   /src/components/page/search_result/search_result.vue
                {
                    path: '/search_result',
                  //   name: 'info',
                    component: resolve => require(['@/components/page/search_result/search_result.vue'], resolve),
                    meta: { title: '搜索结果' }
                },

                {
                    path: '/info',
                  //   name: 'info',
                    component: resolve => require(['@/components/page/info/details.vue'], resolve),
                    meta: { title: '单页管理' }
                },





                {
                    path: '/404',
                    component: resolve => require(['@/components/page/404.vue'], resolve),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: resolve => require(['@/components/page/403.vue'], resolve),
                    meta: { title: '403' }
                }
            ]
        },
        // {
        //     path: '/login',
        //      name: 'login',
        //     component: resolve => require(['@/components/page/admin/Login.vue'], resolve)
        // },

        // {
        //     path: '/Logout',
        //      name: 'Logout',
        //     component: resolve => require(['@/components/page/admin/Logout.vue'], resolve)
        // },


        {
            path: '*',
            redirect: '/404'
        }
    ]
})



const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => {
      console.info(">>>>>>>>>>>>>>>>> ",err);
     return err
   })
}



// WEBPACK FOOTER //
// ./src/router/index.js